export default "__VITE_ASSET__BRxQSoLm__"